import { useTranslation } from 'react-i18next';

export const useSelectedAppLanguage = (): string => {
    const { i18n } = useTranslation();
    return i18n.language;
};
